var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastro !== undefined
    ? _c(
        "div",
        { staticClass: "analise" },
        [
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _vm.cadastro
                ? _c(
                    "el-card",
                    {
                      staticClass: "card-collapse",
                      attrs: { shadow: "hover" }
                    },
                    [
                      [
                        _c("app-dados-responsavel", {
                          attrs: {
                            responsavel: _vm.cadastro.responsavel,
                            isCadastroPendente: true,
                            cadastroGeo: _vm.cadastro
                          }
                        }),
                        _c("app-documentos", {
                          attrs: {
                            aba: "Georreferenciamento",
                            isAnalise: false,
                            idUploadDocumento: "documentoGeorreferenciamento",
                            titulo: "Georreferenciamento",
                            maxSize: 25000,
                            "valid-extensions": _vm.extensoes,
                            documentos: _vm.cadastro.documentos,
                            tiposDocumentos: _vm.tipoDocumentosGeomensor,
                            tiposDocumentosObrigatorios:
                              _vm.tipoDocumentosGeomensorObrigatorios,
                            pecasTecnicas: true,
                            observer: this.$refs.validation
                          },
                          on: {
                            mudaTipo: _vm.mudaTipo,
                            setDadosPlanilha: _vm.setDadosPlanilha
                          }
                        })
                      ]
                    ],
                    2
                  )
                : _vm._e(),
              _c("app-buttons-cadastro", {
                attrs: {
                  isUltimoPasso: _vm.isUltimoPasso,
                  isPrimeiroPasso: !_vm.isUltimoPasso,
                  showButtonSalvar: true,
                  showButtonProximo: true
                },
                on: {
                  proximo: _vm.proximo,
                  finalizar: _vm.finalizar,
                  cancelar: _vm.cancelar,
                  salvar: _vm.salvar,
                  voltar: _vm.voltar
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-089db977", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089db977","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/GerarGeoCadastroPendente.vue
// module id = null
// module chunks = 